// app/javascript/controllers/auto_open_drawer_controller.js
// Opens the global drawer on page load (e.g. the comments of a post reached from a comment notification).
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        src: String
    }

    connect() {
        if (!this.srcValue) return

        const src = this.srcValue
        // Consume it: a reconnect (Turbo cache restore, DOM move) must not reopen the drawer.
        this.element.remove()

        // Let the global drawer controller connect first.
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent("global-drawer:open", {
                bubbles: true,
                detail: {src}
            }))
        }, 300)
    }
}
